<template>
  <div>
    <MasterLayout>
      <div class="pt-5 pb-3 pl-4 pr-3 dashboard_first_row">
        <div class="row">
          <div class="col-md-8">
            <div class="py-5 pt-5 mb-3 row align-items-center white-bg">
              <div class="col-md-1 remove-right-padding col-center-flex">
                <div class="square-icon-wrapper small sky-bg">
                  <img src="@/assets/img/cogwheels.png" width="40px" />
                </div>
              </div>
              <div class="py-1 col-md-6">
                <h4 class="primary-color font-600">
                  {{ $t("text.pumpsFault.maintenanceList") }}
                </h4>
                <p class="mt-3 light-grey-text">
                  {{ $t("text.pumpsFault.viewMaintenanceList") }}
                </p>
              </div>
              <div class="col-md-5 flexify"></div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="py-4 card_container">
              <div class="card__header___text">
                <div>
                  <h3 class="text-center our_branches__header">
                    {{ $t("text.pumpsFault.totalMaintenance") }}
                  </h3>
                  <div class="mt-3 dealer__icon__wrapper">
                    <div class="text-center dealer__icon__div">
                      <div>
                        <img src="@/assets/img/cogwheels.png" width="40px" />
                      </div>
                    </div>
                  </div>
                  <h3 class="mt-2 text-center our_branches__header">
                    {{ faultsNo }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="invoice-banner mt-3">
          <!-- Pump Fault Status -->
          <div class="row align-items-center fuel_consumption_buttons_row">
            <div class="col-md-12 fuel_consumption_btn_div mt-3">
              <div
                class="fuel_consumption_button installed__tanks_dropdown__row showAllContainer"
                width="100%"
                style="
                  width: 100%;
                  padding: 5px;
                  background: rgb(75, 44, 114);
                  cursor: pointer;
                "
              >
                <div
                  class="row installed__pumps_dropdown align-items-center"
                  @click="toggleTransactionsDropDown"
                  v-on:mouseleave="
                    showStatusOPtions === true
                      ? (showStatusOPtions = false)
                      : ''
                  "
                >
                  <div class="col-md-3 dropdown_img">
                    <img src="@/assets/img/y.png" />
                  </div>
                  <div class="col-md-7">
                    <input
                      type="text"
                      class="installed__pumps_dropdown_input"
                      readonly
                      v-model="pumpStatus"
                    />
                  </div>
                  <div class="col-md-2">
                    <div>
                      <i
                        style="float: right; font-size: 25px; color: white"
                        class="fa fa-angle-right"
                        :class="[showStatusOPtions ? 'downArrow' : 'upArrow']"
                      ></i>
                    </div>
                  </div>

                  <div
                    class="return_balance_to_drop_dwon"
                    ref="balance_to_drop_down_menu"
                    v-if="showStatusOPtions"
                  >
                    <hr class="mt-2" />
                    <div
                      class="row mt-2 active_validity_drop_down_list align-items-center"
                      ref="balance_to_list_row"
                      @click="selectItem($t('text.pumpsFault.showAll'))"
                      style="height: 40px"
                    >
                      <div class="col-md-12 text-center">
                        <h6
                          class="dropdown_header_text mt-2 validity_drop_down_list"
                          ref="validity_drop_down_list"
                        >
                          {{ $t("text.pumpsFault.showAll") }}
                        </h6>
                      </div>
                    </div>
                    <div
                      class="row mt-2 active_validity_drop_down_list align-items-center"
                      ref="balance_to_list_row"
                      style="height: 40px"
                      @click="selectItem($t('text.pumpsFault.pending'))"
                    >
                      <div class="col-md-12 text-center">
                        <h6
                          class="dropdown_header_text mt-2 validity_drop_down_list"
                          ref="validity_drop_down_list"
                        >
                          {{ $t("text.pumpsFault.pending") }}
                        </h6>
                      </div>
                    </div>
                    <div
                      class="row mt-2 active_validity_drop_down_list align-items-center"
                      style="height: 40px"
                      ref="balance_to_list_row"
                      @click="selectItem($t('text.pumpsFault.fixing'))"
                    >
                      <div class="col-md-12 text-center">
                        <h6
                          class="dropdown_header_text mt-2 validity_drop_down_list"
                          ref="validity_drop_down_list"
                        >
                          {{ $t("text.pumpsFault.fixing") }}
                        </h6>
                      </div>
                    </div>
                    <div
                      class="row mt-2 active_validity_drop_down_list align-items-center"
                      ref="balance_to_list_row"
                      style="height: 40px"
                      @click="selectItem($t('text.pumpsFault.fixed'))"
                    >
                      <div class="col-md-12 text-center">
                        <h6
                          class="dropdown_header_text mt-2 validity_drop_down_list"
                          ref="validity_drop_down_list"
                        >
                          {{ $t("text.pumpsFault.fixed") }}
                        </h6>
                      </div>
                    </div>
                    <div
                      class="row mt-2 active_validity_drop_down_list align-items-center"
                      ref="balance_to_list_row"
                      style="height: 40px"
                      @click="selectItem($t('text.pumpsFault.notFixed'))"
                    >
                      <div class="col-md-12 text-center">
                        <h6
                          class="dropdown_header_text mt-2 validity_drop_down_list"
                          ref="validity_drop_down_list"
                        >
                          {{ $t("text.pumpsFault.notFixed") }}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-center voucher_type mt-2 primary_text">
                {{ $t("text.pumpsFault.pumpStatus") }}
              </div>
            </div>
          </div>
          <!-- Pump Fault Status End -->
          <div class="aggregate_change_input_wrapper w-25">
            <vue-ctk-date-time-picker
              v-model="dateRange"
              :max-date="maxDate"
              :range="true"
              :autoClose="true"
              :locale="this.$root.$i18n.locale"
              :color="$store.getters.getDatePickerColor"
              format="YYYY-MM-DDTHH:mm:ss"
              formatted="DD/MM/YYYY"
              :label="$t('text.calendar.selectDate')"
            />
          </div>
        </div>
      </div>

      <section class="pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div class="col-md-12 col-lg-12">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowTextWrap="true"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="50" field="index" headerText="#"></e-column>
                <e-column
                  field="date"
                  width="200"
                  :format="formatOptions"
                  type="date"
                  :headerText="$t('text.pumpsMaintenance.date')"
                ></e-column>
                <e-column
                  field="branchName"
                  width="180"
                  headerText="Branch"
                ></e-column>
                <e-column
                  field="pumpName"
                  width="200"
                  :headerText="$t('text.pumpsMaintenance.pumpName')"
                ></e-column>
                <e-column
                  width="180"
                  field="fault"
                  :headerText="$t('text.pumpsMaintenance.fault')"
                ></e-column>
                <e-column
                  field="technicianName"
                  width="200"
                  :headerText="$t('text.pumpsMaintenance.technician')"
                ></e-column>
                <e-column
                  field="servicingCompany"
                  width="200"
                  :headerText="$t('text.pumpsMaintenance.servicingCompany')"
                ></e-column>
                <e-column
                  field="remarks"
                  width="200"
                  :headerText="$t('text.pumpsMaintenance.remarks')"
                ></e-column>
                <e-column
                  field="status"
                  width="180"
                  :headerText="$t('text.pumpsMaintenance.status')"
                ></e-column>
                <!-- <e-column
                  field="date"
                  width="200"
                  :headerText="$t('text.pumpsMaintenance.date')"
                  :sortComparer="sortComparer"
                ></e-column> -->
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Dealer/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Maintenance List :: Epump Portal",
  name: "MaintenanceList",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      dateRange: {
        start: this.$moment().subtract(7, "days").format("YYYY-MM-DDTHH:mm:ss"),
        end: this.$moment().format("YYYY-MM-DDTHH:mm:ss"),
      },
      dealer: null,
      backgroundUrl,
      cardBackgroundUrl,
      showLoader: true,
      showStatusOPtions: false,
      pumpStatus: this.$t("text.pumpsFault.showAll"),
      faultsNo: "",
      users: [],
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search", "ExcelExport", "PdfExport"],
      search: { operator: "contains", ignoreCase: true },
    };
  },
  watch: {
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.updateRouteQuery();
        this.getAggregatedFaults();
      }
    },
    dealer(dealer) {
      if (dealer !== null) {
        this.getAggregatedFaults();
      }
    },
  },
  created() {
    this.$eventHub.$on("dealer", (dealer) => {
      this.dealer = dealer;
    });
    if (this.$route.query.dealerId) {
      this.getAggregatedFaults();
    }
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
    this.updateRouteQuery();
  },
  methods: {
    updateRouteQuery() {
      let queries = JSON.parse(JSON.stringify(this.$route.query));
      queries.dateRange = JSON.stringify(this.dateRange);
      this.$router.replace({ query: queries });
    },
    // sortComparer(reference, comparer) {
    //   reference = this.$moment(reference, "DD/MM/YYYY  hh:mm A").format();
    //   comparer = this.$moment(comparer, "DD/MM/YYYY  hh:mm A").format();
    //   if (reference < comparer) {
    //     return -1;
    //   } else if (reference > comparer) {
    //     return 1;
    //   } else {
    //     return 0;
    //   }
    // },
    toggleTransactionsDropDown() {
      this.showStatusOPtions = !this.showStatusOPtions;
    },
    openModal($modal) {
      this.$modal.show($modal);
    },
    selectItem(status) {
      this.pumpStatus = status;
      this.getAggregatedFaults();
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "Maintenance_List.pdf",
          };
          this.$refs.dataGrid.getColumns()[0].width = "80";
          this.$refs.dataGrid.getColumns()[1].width = "200";
          this.$refs.dataGrid.getColumns()[2].width = "140";
          this.$refs.dataGrid.getColumns()[3].width = "200";
          this.$refs.dataGrid.getColumns()[4].width = "200";
          this.$refs.dataGrid.getColumns()[5].width = "120";
          this.$refs.dataGrid.getColumns()[6].width = "120";
          this.$refs.dataGrid.getColumns()[7].width = "120";
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          // this.$refs.dataGrid.getColumns()[4].visible = false;
          // this.$refs.dataGrid.getColumns()[5].visible = true;
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {},
    // rowDataBound: function (args) {
    //   if (args.data["status"] === "Active") {
    //     args.row.cells[4].style.color = "green";
    //   }
    //   if (args.data["status"] === "Deactivated") {
    //     args.row.cells[4].style.color = "blue";
    //   }
    //   if (args.data["status"] === "Suspended") {
    //     args.row.cells[4].style.color = "red";
    //   }
    // },
    getAggregatedFaults() {
      let url;
      this.showLoader = true;
      if (this.pumpStatus === this.$t("text.pumpsFault.showAll")) {
        url = `${configObject.apiBaseUrl}/Pumps/DealerMaintainance/${
          this.$route.query.dealerId
            ? this.$route.query.dealerId
            : this.dealer.id
        }?startDate=${this.dateRange.start}&endDate=${this.dateRange.end}`;
      }
      if (this.pumpStatus === "Pending") {
        url = `${configObject.apiBaseUrl}/Pumps/DealerMaintainance/${
          this.$route.query.dealerId
            ? this.$route.query.dealerId
            : this.dealer.id
        }/All?status=pending&startDate=${this.dateRange.start}&endDate=${
          this.dateRange.end
        }`;
      }
      if (this.pumpStatus === "Fixing") {
        url = `${configObject.apiBaseUrl}/Pumps/DealerMaintainance/${
          this.$route.query.dealerId
            ? this.$route.query.dealerId
            : this.dealer.id
        }/All?status=fixing&startDate=${this.dateRange.start}&endDate=${
          this.dateRange.end
        }`;
      }
      if (this.pumpStatus === "Fixed") {
        url = `${configObject.apiBaseUrl}/Pumps/DealerMaintainance/${
          this.$route.query.dealerId
            ? this.$route.query.dealerId
            : this.dealer.id
        }/All?status=fixed&startDate=${this.dateRange.start}&endDate=${
          this.dateRange.end
        }`;
      }
      if (this.pumpStatus === "Not Fixed") {
        url = `${configObject.apiBaseUrl}/Pumps/DealerMaintainance/${
          this.$route.query.dealerId
            ? this.$route.query.dealerId
            : this.dealer.id
        }/All?status=not fixed&startDate=${this.dateRange.start}&endDate=${
          this.dateRange.end
        }`;
      }
      this.axios
        .get(url, configObject.authConfig())
        .then((response) => {
          // console.log(response);
          this.showLoader = false;
          this.faults = response.data;
          this.faultsNo = response.data.length;
          let index = 0;
          response.data.sort((a, b) => {
            return a.date > b.date ? 1 : -1;
          });
          response.data.forEach((element) => {
            element.index = ++index;
            element.dateUnformatted = element.date;
          });
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>

<style></style>
